import './video_section.css'
import Video from './video/sof.mov'
// import photo from './video/header.png'

const Video_section = () => {

    return (
        <div className={'video_section'}>
            <div className="video">
                <video playsInline autoPlay={true} src={Video} typeof="video/mp4" loop muted/>
                {/*<img src={photo} alt=""/>*/}
            </div>
            <div className="video_text">
                {/*<div className="video_text_title">*/}
                {/*    <div className="video_text_title_head">*/}
                {/*        SOF*/}
                {/*    </div>*/}
                {/*    <div className="video_text_title_body">*/}
                {/*        cafe & restaurant*/}
                {/*    </div>*/}
                {/*    <div className="video_text_description">*/}
                {/*       ~ Since 2022 ~*/}
                {/*    </div>*/}
                {/*</div>*/}

            </div>
            <div className="gradient"/>
        </div>
    )
}

export default Video_section
